import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';
import MeetingButton from 'flow/components/meeting/MeetingButton';
import { getFooterButtonHiddenClass } from 'flow/utils/meeting-footer-utils';

interface Props {
    onClick: () => void;
}

const ButtonOpenCloseJoinInfo = ({ onClick }: Props) => {
    const { i18next } = useAppContext();
    return (
        <div
            className={twMerge(
                'flex items-center select-none',
                getFooterButtonHiddenClass(),
            )}
        >
            <MeetingButton
                iconType="infoOutlinedIcon"
                active={false}
                invertOnHover={true}
                callback={onClick}
                hoverText={i18next.t(
                    'videoconference.controlpanel.joining_info',
                )}
                circular={true}
            />
        </div>
    );
};

export default ButtonOpenCloseJoinInfo;
